import React from 'react'
import { BulkCreateShiftsProvider } from './context/BulkCreateShiftsProvider'
import { BulkCreateShiftsMain } from './components/BulkCreateShiftsMain'

export const BulkCreateShifts = () => {
  return (
    <BulkCreateShiftsProvider>
      <BulkCreateShiftsMain />
    </BulkCreateShiftsProvider>
  )
}
